import React from 'react';
import { Message as MessageType } from '@/types';

interface MessageProps {
  message: MessageType;
}

/**
 * Lightweight Markdown formatter for assistant messages.
 * Escapes HTML to prevent XSS, then converts a small subset of Markdown
 * (bold, italic, line breaks) into safe HTML. Keeps the bundle tiny.
 */
function formatAssistantContent(content: string): string {
  let html = content
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')

  // Bold: **text** or __text__
  html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
  html = html.replace(/__(.+?)__/g, '<strong>$1</strong>')

  // Italic: *text* or _text_ (not already consumed by bold)
  html = html.replace(/(^|[^*])\*(.+?)\*(?=[^*]|$)/g, '$1<em>$2</em>')
  html = html.replace(/(^|[^_])_(.+?)_(?=[^_]|$)/g, '$1<em>$2</em>')

  // Line breaks
  html = html.replace(/\n/g, '<br>')

  // Markdown links: [text](https://url) — only http/https schemes allowed
  html = html.replace(
    /\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g,
    '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
  )

  return html
}

export const MessageBubble: React.FC<MessageProps> = ({ message }) => {
  const isUser = message.role === 'user';

  return (
    <div className={`r3c-message ${isUser ? 'r3c-message--user' : 'r3c-message--assistant'}`}>
      <div className="r3c-message__content">
        {isUser ? (
          message.content
        ) : (
          <span dangerouslySetInnerHTML={{ __html: formatAssistantContent(message.content) }} />
        )}
      </div>
      <div className="r3c-message__time">
        {new Date(message.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
      </div>
    </div>
  );
};
